import api from "../../Services/api";

export const fetchForms = async () => {
  try {
    const response = await api.get("/forms/all", {
      data: {},
    });
    return response.data.forms;
  } catch (error) {
    console.error("Error fetching forms:", error);
    throw error;
  }
};

export const fetchUserCreatedFormFilledFormsCSV = async (formId) => {
  try {
    const response = await api.get(
      `/filled-forms/formSchemaId/${formId}/download-csv`
    );
    return response.data.filledForms || [];
  } catch (error) {
    console.error("Error fetching filled forms:", error);
    throw error;
  }
};

export const fetchFilledforms = async () => {
  try {
    const response = await api.get("/filled-forms/all", {
      data: {},
    });
    return response.data.filledForms;
  } catch (error) {
    console.error("Error fetching filledForms:", error);
    throw error;
  }
};

export const updateStatus = async (formId, status) => {
  try {
    const response = await api.put(`/forms/toggle-status/${formId}`, {
      status,
    });
    return response.data.form;
  } catch (error) {
    console.error("Error updating form status:", error);
    throw error;
  }
};

export const handleHardDeleteForm = async (formId) => {
  try {
    const response = await api.delete(`/forms/delete/${formId}`);
    return response.data.form;
  } catch (error) {
    console.error("Error deleting form:", error);
    throw error;
  }
};

export const handleSoftDeleteForm = async (formId) => {
  try {
    const response = await api.put(`/forms/toggle-soft-delete/${formId}`);
    return response.data.form;
  } catch (error) {
    console.error("Error soft deleting form:", error);
    throw error;
  }
};

export const handleResetForm = async (formId) => {
  try {
    const response = await api.delete(`/filled-forms/reset/${formId}`);
    return response.data.form;
  } catch (error) {
    console.error("Error resetting form:", error);
    throw error;
  }
};

export const updateFormUsage = async (formId, usage) => {
  try {
    const response = await api.put(`/forms/update-usage/${formId}`, {
      usage,
    });
    return response.data.form;
  } catch (error) {
    console.error("Error updating form usage:", error);
    throw error;
  }
};
